import React from "react";
import moment from "moment";

import { t } from "../../../helpers/translator";
import { betOutcomes, betTypes, BET_OUTCOME_UNSETTLED } from "../../../constants/betHistory";
import { predefinedDateRanges } from '../../../constants/balanceHistory';
import CashoutIcon from '../../../images/Cashout.png'
import CopyIcon from '../../../images/copy.png'

export default function betHistoryTemplate () {
    const { history, betHistoryFilterId, isLoadedHistory } = this.props;

    return (
        <div className="ticket-results-view-p">
            <div className='history-popup-title'>
                Bet History
            </div>
            <div className='date-ranges-container'>
                {
                    predefinedDateRanges.map(item => (
                        <div
                            key={item.id}
                            value={item.id}
                            className={`date-range ${betHistoryFilterId === item.id ? 'selected' : ''}`}
                            onClick={() => this.selectHendlerchange(item.id)}
                        >
                            {t(item.name)}
                        </div>
                    ))
                }
                {/* <select onChange={this.selectHendlerchange} value={betHistoryFilterId}>
                    {
                        predefinedDateRanges.map(item => {
                            return <option key={item.id} value={item.id} > {t(item.name)} </option>;
                        })
                    }
                </select> */}
            </div>
            <div className="history-info">
                <div className="history-info-inner">
                    <div className="history-info-container">
                        <div className="history-info-container-row header">
                            <div className="history-info-container-row-open">
                                <div className="history-info-container-row-open-inner"/>
                            </div>
                            <div className="history-info-container-row-inner">{t("Date")}</div>
                            <div className="history-info-container-row-inner">{t("Status")}</div>
                            <div className="history-info-container-row-inner">{t("Type")}</div>
                            <div className="history-info-container-row-inner">{t("Amount")}</div>
                            <div className="history-info-container-row-inner">{t("Price")}</div>
                            <div className="history-info-container-row-inner">{t("Poss. Win")}</div>
                            <div className="history-info-container-row-inner">{t("Win. Amount")}</div>
                            <div className="history-info-container-row-inner">{t("Payment Method")}</div>
                            <div className="history-info-container-row-bet-state">
                                {/* <div>{t("Cashout")}</div>
                                 <div>{t("Copy Bet")}</div> */}
                            </div>
                        </div>
                        {!isLoadedHistory ? (t('Loading...'))
                            : history.bets?.map((item, index) => {
                                return (
                                    <React.Fragment>
                                        <div className= {`history-info-container-row ${(this.state.openSelectionInfo === index) && 'active'}`}  onClick={ () => this.selectBetHistoryInfo(index) }>
                                            <div className={`history-info-container-row-open ${this.state.openSelectionInfo === index ? "close" : "open"}`}></div>
                                            <div className="history-info-container-row-inner">{moment.unix(item.date_time).format("MM-DD-YYYY, H:mm")}</div>
                                            <div className="history-info-container-row-inner">{betOutcomes[item.outcome]}</div>
                                            <div className="history-info-container-row-inner">{betTypes[item.type]}</div>
                                            <div className="history-info-container-row-inner">{item.bonus_bet_amount !== 0 ? item.bonus_bet_amount + ' ' + item.currency : item.amount + ' ' + item.currency}</div>
                                            <div className="history-info-container-row-inner">{item.k}</div>
                                            <div className="history-info-container-row-inner">{item.possible_win + ' ' + item.currency}</div>
                                            <div className="history-info-container-row-inner">{item.payout + ' ' + item.currency}</div>
                                            <div className="history-info-container-row-inner">{item.amount === 0 && item.bonus_bet_amount !== 0 ? 'Bonus' : 'Real Money'}</div>
                                            <div className="history-info-container-row-bet-state">
                                                {item.cash_out !== undefined
                                                    ? <div className="history-cashout ">
                                                        <img src={CashoutIcon} onClick={this.betHistoryCashout(item.id, item.cash_out)}/>
                                                    </div>
                                                    : null
                                                }
                                            </div>
                                        </div>
                                        <div className="history-info-container-inside">
                                            <div className="history-info-container-inside-row header">
                                                <div className="history-info-container-inside-row-name">{t("Selection")}</div>
                                                <div className="history-info-container-inside-row-inner">{t("Event")}</div>
                                                <div className="history-info-container-inside-row-inner">{t("Date")}</div>
                                                <div className="history-info-container-inside-row-inner">{t("Odds")}</div>
                                                <div className="history-info-container-inside-row-inner">{t("State")}</div>
                                            </div>
                                            { item.events.map(event => {
                                                return <div className="history-info-container-inside-row">
                                                    <div className="history-info-container-inside-row-name">
                                                        <span className={`sport-icon-m ${event.sport_index}`}/>
                                                        {event.market_name + " - " + event.event_name}
                                                        </div>
                                                    <div className="history-info-container-inside-row-inner">{event.game_name}</div>
                                                    <div className="history-info-container-inside-row-inner">{moment.unix(event.game_start_date).format("MM-DD-YYYY, H:mm")}</div>
                                                    <div className="history-info-container-inside-row-inner">{event.coeficient}</div>
                                                    <div className="history-info-container-inside-row-inner">{betOutcomes[event.outcome]}</div>
                                                </div>;
                                            })
                                            }
                                            <div className='bet-item-actions-container'>
                                                {
                                                    item.cash_out !== undefined &&
                                                        <div className='action-button' onClick={this.betHistoryCashout(item.id, item.cash_out)}>
                                                            <img src={CashoutIcon} />
                                                            {t('Cashout')}
                                                        </div>
                                                }
                                                {
                                                    (betOutcomes[item.outcome] === betOutcomes[BET_OUTCOME_UNSETTLED] || (betOutcomes[item.outcome] === "Cashed out" && moment().utc().format("MM-DD-YYYY") === moment.unix(item.date_time).format("MM-DD-YYYY"))) &&
                                                        <div className='action-button' onClick={(e) => this.copyToBetSlip(index, e)()}>
                                                            <img src={CopyIcon} />
                                                            Copy Bet
                                                        </div>
                                                }
                                            </div>
                                        </div>
                                    </React.Fragment>);
                            })
                        }
                    </div>
                </div>
            </div>
            {/* <div className="buttons-view-w-t">
                <ul>
                    <li>
                        <div className="separator-box-buttons-m">
                            <button
                                className="button-view-normal-m trans-m"
                                onClick={this.props.closePopup()}>
                                {t("OK")}
                            </button>
                        </div>
                    </li>
                </ul>
            </div> */}
        </div>
    );
}
